import { render } from "./uk2.vue?vue&type=template&id=519139e4"
import script from "./uk2.vue?vue&type=script&lang=js"
export * from "./uk2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__